import { auditFields, operations, types } from '../common';

/**
 * Entity schema
 */
const schema = {
  version: 3,

  title: 'Test',
  description: 'Blood donations test',

  primaryKey: 'id',
  type: 'object',
  properties: {
    id: types.ID,
    icode: types.STRING_INDEX,

    testCode: types.STRING_INDEX,
    dueTime: types.DATE_TIME_INDEX,
    status: types.STRING_INDEX, // activity
    details: types.STRING,

    testType: types.OBJECT,
    laboratory: types.OBJECT,
    result: types.OBJECT,
    donation: types.OBJECT,
    adverseEvent: types.OBJECT,
    retentionSample: types.OBJECT,

    consumables: types.ARRAY,
    equipments: types.ARRAY,
    healthCareWorkers: types.ARRAY,

    // Audit fields
    ...auditFields
  },

  required: ['id', 'dueTime', 'testType', 'laboratory', 'donation'],
  indexes: [
    ['testCode'],
    ['dueTime']
  ],
  keyCompression: true
};

/**
 * Migration strategies
 */
const migrationStrategies = {};

/**
 * Collection methods
 */
const statics = {
  /**
   * Creates new instance
   *
   * Also updates full and person names
   *
   * @param {object} data  New instance
   * @returns Promise
   */
  add: function (data) {
    return operations.add(this, data);
  },

  /**
   * Updates instance
   *
   * Also updates full and person names
   *
   * @param {object} data  Instance
   * @returns Promise
   */
  edit: function (data) {
    return operations.edit(this, data);
  },

  /**
   * Deletes instance
   *
   * @param {string} id  Instance ID
   * @returns Promise
   */
  del: function (id) {
    return operations.del(this, id);
  }
};

/**
 * Instance methods
 */
const methods = {};

/**
 * Collection definition
 */
const collection = { schema, migrationStrategies, statics, methods };

export default collection;
